import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  IBoardItemConfiguration,
  IItemCategory,
} from '../../pages/dashboard-content/widget-add-edit-dialog/widget-add-edit-dialog.interface';
import { IDropdownOption } from '../../shared/components/mat-dropdown/mat-dropdown.component';

@Injectable({ providedIn: 'root' })
export class ActionTrackerService {
  public static getitemCategoryTypeOptions(translate: TranslateService): IDropdownOption<string>[] {
    return [
      { id: 'safety', name: translate.instant('widget.sqcdpMonthly.sqcdpType.safety') },
      { id: 'quality', name: translate.instant('widget.sqcdpMonthly.sqcdpType.quality') },
      { id: 'cost', name: translate.instant('widget.sqcdpMonthly.sqcdpType.cost') },
      { id: 'delivery', name: translate.instant('widget.sqcdpMonthly.sqcdpType.delivery') },
      { id: 'people', name: translate.instant('widget.sqcdpMonthly.sqcdpType.people') },
    ];
  }

  public static buildCategoryDropdownOptions(
    data: IBoardItemConfiguration[],
    translate: TranslateService,
  ): IDropdownOption<number>[] {
    return data.reduce((acc, item) => {
      if (!item.itemCategory || acc.some((option) => option.id === item.itemCategory.id)) {
        return acc;
      }

      const category: IItemCategory = item.itemCategory;

      const translatedName: string = category.isDefault
        ? translate.instant(
            ActionTrackerService.getitemCategoryTypeOptions(translate).find((option) => option.id === category.name)
              ?.name ?? category.name,
          )
        : category.name;

      acc.push({
        id: category.id,
        name: translatedName,
      });

      return acc;
    }, [] as IDropdownOption<number>[]);
  }
}
